/* @flow */

export const FETCH_AVAILABLE_LOAN_HISTORIES_REQUEST = 'FETCH_AVAILABLE_LOAN_HISTORIES_REQUEST';
export const FETCH_AVAILABLE_LOAN_HISTORIES_SUCCESS = 'FETCH_AVAILABLE_LOAN_HISTORIES_SUCCESS';
export const FETCH_AVAILABLE_LOAN_HISTORIES_FAILURE = 'FETCH_AVAILABLE_LOAN_HISTORIES_FAILURE';

export function success(payload) {
  return (dispatch) => {
    dispatch({
      type: FETCH_AVAILABLE_LOAN_HISTORIES_SUCCESS,
      payload,
    });
  };
}

export function failure(resource) {
  return (dispatch) => {
    dispatch({
      type: FETCH_AVAILABLE_LOAN_HISTORIES_FAILURE,
      payload: resource,
    });
  };
}

export default function fetch(params) {
  return (dispatch) => {
    dispatch({
      type: FETCH_AVAILABLE_LOAN_HISTORIES_REQUEST,
      payload: {
        params,
      },
    });
  };
}
